import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FREE_SHIPPING, formatPrice } from "@/lib/site";

const sections = (product) => [
  {
    id: "spedizione",
    title: "Spedizione",
    text: product.source === "gelato"
      ? `Stampato su richiesta da Gelato nel laboratorio più vicino a te e spedito in 3–7 giorni lavorativi. Spedizione gratuita sopra ${formatPrice(FREE_SHIPPING)}.`
      : `Preparato a mano e spedito entro 48 ore, consegna in 2–5 giorni lavorativi. Spedizione gratuita sopra ${formatPrice(FREE_SHIPPING)}.`,
  },
  {
    id: "resi",
    title: "Resi e cambi",
    text: product.source === "gelato"
      ? "I prodotti stampati su richiesta sono personalizzati per te: se arrivano difettosi o danneggiati li sostituiamo gratis entro 14 giorni."
      : "Hai 14 giorni dalla consegna per il reso o il cambio taglia. Scrivici e ti mandiamo le istruzioni.",
  },
  {
    id: "pagamenti",
    title: "Pagamenti sicuri",
    text: "Paghi con carta, Apple Pay o Google Pay tramite Stripe, oppure con PayPal. Non salviamo mai i dati della tua carta.",
  },
];

export const ProductDetails = ({ product }) => (
  <Accordion type="single" collapsible className="border-t border-line" data-testid="product-details-accordion">
    {sections(product).map((s) => (
      <AccordionItem key={s.id} value={s.id} className="border-line">
        <AccordionTrigger data-testid={`product-accordion-${s.id}`} className="font-mono text-[11px] uppercase tracking-[0.25em] hover:text-acid hover:no-underline">
          {s.title}
        </AccordionTrigger>
        <AccordionContent className="text-sm leading-relaxed text-bone/70">{s.text}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
